import { COW_SHED_1_0_0_VERSION, COW_SHED_LATEST_VERSION, CoWShedVersion } from '@cowprotocol/sdk-cow-shed'

import { msg } from '@lingui/core/macro'

export const COW_SHED_VERSIONS: CoWShedVersion[] = [COW_SHED_LATEST_VERSION, COW_SHED_1_0_0_VERSION]

export const NEED_HELP_LABEL = msg`Need help`
